import api from './api';
import {AppResponse} from "../models/common/app-response";
import { HealthCertificateTypeDto } from '../models/healthCertificates/healthCertificateType.dto';

class HealthCertificateTypesService {
    get() {
        return api.get<AppResponse<HealthCertificateTypeDto[]>>(`/api/v1/health-certificate-types`);
    }
}

export const healthCertificateTypesService = new HealthCertificateTypesService();